import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { ui } from '@/constants';
import { ScanlessIntroductionContentFragment } from '@/models/cms';

@Component({
  name: 'CmgScanlessInfoIconModal',
})
export default class CmgScanlessInfoIconModal extends Vue {
  private infoIconContentState: ScanlessIntroductionContentFragment = { isModalEnabled: false };

  get visible(): boolean {
    return this.$appStore.state.ui.modals.scanlessInfoIconModal.visible;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get infoIconContent(): ScanlessIntroductionContentFragment {
    return this.infoIconContentState;
  }

  get modalImageSrc(): string {
    return this.$appStore.state.cms.images.logos.medallionRewardShout?.default
      || this.$appStore.state.cms.images.logos.medallion.default;
  }

  get modalTitle(): string {
    return this.infoIconContent.heading || 'AUTO ACCRUAL';
  }

  get modalDisplayTitle(): string {
    if (/AUTO\s+ACCRUAL/i.test(this.modalTitle)) {
      return this.modalTitle.replace(/\s+ACCRUAL\b/i, '\nACCRUAL');
    }

    return this.modalTitle;
  }

  get modalBodyHtml(): string {
    return this.infoIconContent.bodyHtml || '';
  }

  get modalFooterHtml(): string {
    return this.infoIconContent.footerHtml || '';
  }

  @Watch('visible', { immediate: true })
  async onVisibleChanged(isVisible: boolean): Promise<void> {
    this.infoIconContentState = this.$services.config.getScanlessInfoIconModal();

    if (isVisible && !this.infoIconContentState.isModalEnabled) {
      await this.$services.config.setScanlessInfoIconModal();
      this.infoIconContentState = this.$services.config.getScanlessInfoIconModal();
    }
  }

  close(): void {
    this.$services.ui.setModalVisibility('scanlessInfoIconModal', false);
  }
}
